"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createRouter = void 0;
exports.resetRouter = resetRouter;
require("core-js/modules/web.url-search-params.delete.js");
require("core-js/modules/web.url-search-params.has.js");
require("core-js/modules/web.url-search-params.size.js");
var _antDesignVue = require("ant-design-vue");
var _vue = _interopRequireDefault(require("vue"));
var _vueRouter = _interopRequireDefault(require("vue-router"));
var _version = require("@/api/version");
var _buryingPointRouteGuard = _interopRequireDefault(require("./buryingPointRouteGuard"));
var _routes = _interopRequireDefault(require("./routes"));
/**
 * 全站路由配置
 *
 * meta参数说明
 * keepAlive是否缓冲页面
 * isTab是否加入到tag导航
 * isAuth是否需要授权
 */

// hack router push callback
const originalPush = _vueRouter.default.prototype.push;
_vueRouter.default.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch(err => err);
};
_vue.default.use(_vueRouter.default);
// 创建路由
const createRouter = () => {
  const router = new _vueRouter.default({
    mode: 'history',
    // https://router.vuejs.org/zh/guide/advanced/scroll-behavior.html#%E5%BC%82%E6%AD%A5%E6%BB%9A%E5%8A%A8
    // 这个方法 是控制滚动条
    // 如果 return falsy || {} ,则不发生滚动
    scrollBehavior(to, from, savedPosition) {
      // savedPosition 这个参数当且仅当导航 (通过浏览器的 前进/后退 按钮触发) 时才可用  效果和 router.go() 或 router.back()
      if (savedPosition) {
        // 返回savedPosition 其实就是 当用户点击 返回的话，保持之前游览的高度
        return savedPosition;
      }
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop;
      }
      return {
        x: 0,
        y: to.meta.savedPosition || 0
      };
    },
    routes: _routes.default
  });
  return router;
};
exports.createRouter = createRouter;
const router = createRouter(); // 获得 route 实例

router.beforeEach(async (to, from, next) => {
  if (to.path !== from.path) {
    checkVersion();
  }
  next();
});
(0, _buryingPointRouteGuard.default)(router);
const checkVersion = async () => {
  const {
    data: {
      version
    } = {}
  } = await (0, _version.getVersion)();
  if (version !== process.env.VUE_APP_VERSION) {
    _antDesignVue.Modal.warning({
      content: '版本更新，请刷新获取新版本',
      onOk: () => {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('timestamp', Date.now());
        window.location.href = currentUrl.toString();
      }
    });
  }
};
function resetRouter() {
  // 重置路由 比如用于身份验证失败，需要重新登录时 先清空当前的路有权限
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
var _default = exports.default = router;